import DataKeys from 'k8s/DataKeys'
import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import {
  allTenantsSelector,
  userTenantsSelector,
} from 'app/plugins/account/components/userManagement/tenants/selectors'
import { emptyObj } from 'utils/fp'
import { latestMessageByVolumeSelector } from '../messages/selectors'

const emptyMessageMap = {}

export const volumeTransfersSelector = createSharedSelector(
  getDataSelector<DataKeys.VolumeTransfers>(DataKeys.VolumeTransfers),
  (volumeTransfers) => {
    return volumeTransfers
  },
)

export const allVolumeTransfersSelector = createSharedSelector(
  getDataSelector<DataKeys.AllVolumeTransfers>(DataKeys.AllVolumeTransfers),
  (volumeTransfers) => {
    return volumeTransfers
  },
)

export const volumesSelector = createSharedSelector(
  getDataSelector<DataKeys.OpenstackVolumes>(DataKeys.OpenstackVolumes),
  allTenantsSelector,
  userTenantsSelector,
  latestMessageByVolumeSelector,
  (volumes, allTenants, userTenants, latestMessageByVolume = emptyMessageMap) => {
    return volumes.map((volume) => {
      // any model changes go here
      return {
        ...volume,
        name: volume?.name || volume?.id,
        tenantName: [...userTenants, ...allTenants]?.find(
          (tenant) => tenant.id === volume?.['os-vol-tenant-attr:tenant_id'],
        )?.name,
        message: latestMessageByVolume[volume?.id], // with poonams change this might be unneeded
      }
    })
  },
)

export const allVolumesSelector = createSharedSelector(
  getDataSelector<DataKeys.AllOpenstackVolumes>(DataKeys.AllOpenstackVolumes),
  allTenantsSelector,
  userTenantsSelector,
  latestMessageByVolumeSelector,
  (volumes, allTenants, userTenants, latestMessageByVolume = emptyMessageMap) => {
    return volumes.map((volume) => {
      // any model changes go here
      return {
        ...volume,
        name: volume?.name || volume?.id,
        tenantName: [...userTenants, ...allTenants]?.find(
          (tenant) => tenant.id === volume?.['os-vol-tenant-attr:tenant_id'],
        )?.name,
        message: latestMessageByVolume[volume?.id],
      }
    })
  },
)

export const singleVolumeSelector = createSharedSelector(
  getDataSelector<DataKeys.SingleOpenstackVolume>(DataKeys.SingleOpenstackVolume),
  allTenantsSelector,
  userTenantsSelector,
  latestMessageByVolumeSelector,
  (volumes, allTenants, userTenants, latestMessageByVolume = emptyMessageMap) => {
    return volumes.map((volume) => {
      // any model changes go here
      return {
        ...volume,
        name: volume?.name || volume?.id,
        tenantName: [...userTenants, ...allTenants]?.find(
          (tenant) => tenant.id === volume?.['os-vol-tenant-attr:tenant_id'],
        )?.name,
        message: latestMessageByVolume[volume?.id],
      }
    })
  },
)

export const volumesLiteSelector = createSharedSelector(
  getDataSelector<DataKeys.OpenstackVolumesLite>(DataKeys.OpenstackVolumesLite),
  (vms) => vms,
)

export const volumesLiteByIdSelector = createSharedSelector(volumesLiteSelector, (vms) =>
  vms.reduce((accum, vm) => {
    return {
      ...accum,
      [vm.id]: vm,
    }
  }, emptyObj),
)

export const volumesByIdSelector = createSharedSelector(volumesSelector, (volumes) => {
  return volumes.reduce((accum, volume) => {
    return {
      ...accum,
      [volume.id]: volume,
    }
  }, {})
})

export const nonPaginatedVolumesSelector = createSharedSelector(
  getDataSelector<DataKeys.NonPaginatedOpenstackVolumes>(DataKeys.NonPaginatedOpenstackVolumes),
  (volumes) => {
    return volumes
  },
)

export const availableVolumesSelector = createSharedSelector(
  getDataSelector<DataKeys.AvailableOpenstackVolumes>(DataKeys.AvailableOpenstackVolumes),
  allTenantsSelector,
  userTenantsSelector,
  latestMessageByVolumeSelector,
  (volumes, allTenants, userTenants, latestMessageByVolume = emptyMessageMap) => {
    return volumes.map((volume) => {
      // any model changes go here
      return {
        ...volume,
        name: volume?.name || volume?.id,
        tenantName: [...userTenants, ...allTenants]?.find(
          (tenant) => tenant.id === volume?.['os-vol-tenant-attr:tenant_id'],
        )?.name,
        message: latestMessageByVolume[volume?.id], // with poonams change this might be unneeded
      }
    })
  },
)

export const nonPaginatedVolumesByIdSelector = createSharedSelector(
  nonPaginatedVolumesSelector,
  (volumes) => {
    return volumes.reduce((accum, volume) => {
      return {
        ...accum,
        [volume.id]: volume,
      }
    }, {})
  },
)
